import process from "process/browser";
import { createRoot } from "react-dom/client";

// Import Monaco setup first (needs to be before the loader)
import "./monaco-setup";
// Import Monaco loader configuration
import "./monaco-loader";

import Root from "./Root";
import { configStore } from "./redux/AppStore";
import { hasAuthenticatedSession, initializeNavigationPilot } from "./observability/faro";
import { pageLifecycle } from "./observability/faro";
import { observeQueryReadiness } from "./observability/query-readiness";
import { getQueryClient } from "./query-client";

// do not remove, breaks anything using replicated-lint
window.process = process;
if (import.meta.env.VITE_FARO_ENDPOINT) {
  observeQueryReadiness(getQueryClient(), pageLifecycle.signal);
}
const root = createRoot(document.getElementById("app"));

configStore().then(store => {
  if (import.meta.env.VITE_FARO_ENDPOINT) {
    const syncLoading = () => pageLifecycle.reduxLoading(store.getState().ui.main.loading);
    store.subscribe(syncLoading);
    syncLoading();
    initializeNavigationPilot({
      isAuthenticated: () => hasAuthenticatedSession(store.getState()),
      subscribe: listener => store.subscribe(listener),
    });
  }
  root.render(<Root />);
});
